import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { statusTone } from "@/lib/billing";

export function StatusBadge({ status }: { status?: string | null }) {
  const value = status || "unknown";
  return (
    <Badge variant="outline" className={cn("capitalize", statusTone[value] ?? "bg-muted text-muted-foreground border-border")}>
      {value.replaceAll("_", " ")}
    </Badge>
  );
}
